import { SplitEmployeeDocumentDTO } from "../../../models/split-document/split-employee-document/split-employee-document-dto";
import { SplitEmployeeDocumentSTO } from "../../../models/split-document/split-employee-document/split-employee-document-sto";
import { BaseApiService } from "../../../services/base";
import { Period } from "../../../models/documents/period/period";
import { PublishSplitEmployeeDocumentFilter } from "../../../models/split-document/split-employee-document/publish-split-employee-document-filter";
import { CustomDate } from "../../../models//custom-date/custom-date";

export class SplitEmployeeDocumentApiService extends BaseApiService<
  SplitEmployeeDocumentDTO,
  SplitEmployeeDocumentSTO
> {
  constructor() {
    super({
      servicePath: "/SplitEmployeeDocument",
      loadItemsPath: "/GetSplitEmployeeDocument",
      saveItemsPath: "/SaveSplitEmployeeDocument",
    });
  }

  // public publishSplitEmployeeDocumentFiles(
  //   documentTypeId: string,
  //   documentDate: CustomDate | null,
  //   documentPeriod: Period | null
  // ) {
  //   this.useLoadItemsPath("/PublishSplitEmployeedocumentFiles");
  //   return this.loadItems({
  //     documentTypeId: documentTypeId,
  //     documentDate: documentDate,
  //     documentPeriod: documentPeriod,
  //   } as PublishSplitEmployeeDocumentFilter);
  // }

  // public async loadItems(
  //   propsFilter?: PropsFilter,
  //   searchFilter?: string,
  //   sorts?: Sort[],
  //   page?: Page,
  //   exactMatch?: boolean,
  //   timeout?: number,
  //   signal?: AbortSignal | undefined,
  //   withoutCompanyAccount?: boolean | undefined
  //   ): Promise<LoadResponse<SplitEmployeeDocumentDTO>> {
  //     return ({
  //       id: "",
  //       invokerId:null,
  //       correlationId:  null,
  //       error: "",
  //       isCanceled: false,
  //       isSucceeded: false,
  //       items :[
  //         {
  //           id : "12",
  //           createdAt : new Date(),
  //           createdByUser : null,
  //           isDeleted : false,
  //           companyAccount : null,
  //           legalEntity : {
  //             name: "FLOR Germany",
  //             code: "FLOR DE",
  //             legislation: {
  //               name: "All legislations",
  //               code: "ALL",
  //               description: "Means all legislations in the system",
  //               country: null,
  //               id: "fdc1c3ac-69ff-4c3c-aa56-2e51220bfca9",
  //               isDeleted: false,
  //               isConstant: false
  //             },
  //             defaultCurrency: null,
  //             defaultPnLType:null,
  //             exchangeRateSource:null,
  //             defaultGTNSourceType: null,
  //             sequence: 0,
  //             companyAccount: {
  //               name: "Roses",
  //               companyAccountType: null,
  //               exchangeRateSource: null,
  //               id: "5ea90518-cdb2-45ef-a802-cb855eae9389",
  //               isDeleted: false,
  //               isConstant: false
  //             },
  //             createdAt: "2024-02-11T20:08:46.579157Z",
  //             createdByUser: null,
  //             modifiedAt: null,
  //             modifiedByUser: null,
  //             id: "45ebf523-7f60-4467-b4b9-d8396cd72f41",
  //             isDeleted: false,
  //             isConstant: false
  //           } as CompanyLegalEntityRef,
  //           originalDocument : null,
  //           splitOn : null,
  //           splitBy : null,
  //           files : [],
  //           documentType : DOCUMENT_TYPES.EmployeePayslip as DocumentTypeRef,
  //           publishedOn : null,
  //           publishedBy : null
  //         },
  //         {
  //           id : "13",
  //           createdAt : new Date(),
  //           createdByUser : null,
  //           isDeleted : false,
  //           companyAccount : null,
  //           legalEntity : {
  //             name: "FLOR Germany",
  //             code: "FLOR DE",
  //             legislation: {
  //               name: "All legislations",
  //               code: "ALL",
  //               description: "Means all legislations in the system",
  //               country: null,
  //               id: "fdc1c3ac-69ff-4c3c-aa56-2e51220bfca9",
  //               isDeleted: false,
  //               isConstant: false
  //             },
  //             defaultCurrency: null,
  //             defaultPnLType:null,
  //             exchangeRateSource:null,
  //             defaultGTNSourceType: null,
  //             sequence: 0,
  //             companyAccount: {
  //               name: "Roses",
  //               companyAccountType: null,
  //               exchangeRateSource: null,
  //               id: "5ea90518-cdb2-45ef-a802-cb855eae9389",
  //               isDeleted: false,
  //               isConstant: false
  //             },
  //             createdAt: "2024-02-11T20:08:46.579157Z",
  //             createdByUser: null,
  //             modifiedAt: null,
  //             modifiedByUser: null,
  //             id: "45ebf523-7f60-4467-b4b9-d8396cd72f41",
  //             isDeleted: false,
  //             isConstant: false
  //           } as CompanyLegalEntityRef,
  //           originalDocument : null,
  //           splitOn : {
  //             year : 2024,
  //             month : 3,
  //             day : 9
  //           },
  //           splitBy : null,
  //           files : [],
  //           documentType : DOCUMENT_TYPES.EmployeePayslip as DocumentTypeRef,
  //           publishedOn : null,
  //           publishedBy : null
  //         }
  //       ],
  //       totalItems :2
  //     } as LoadResponse<SplitEmployeeDocumentDTO>)
  // }

  // public async splitEmployeeDocument (
  //   splitEmployeeDocumentId : string
  // ) {

  //   return ({
  //     id: "",
  //     invokerId:null,
  //     correlationId:  null,
  //     error: "",
  //     isCanceled: false,
  //     isSucceeded: false,
  //     items :[
  //       {
  //         splitEmployeeDocument :{
  //           id : "12",
  //           isDeleted : false,
  //           companyAccount : null,
  //           legalEntity : {
  //             name: "FLOR Germany",
  //             code: "FLOR DE",
  //             legislation: {
  //               name: "All legislations",
  //               code: "ALL",
  //               description: "Means all legislations in the system",
  //               country: null,
  //               id: "fdc1c3ac-69ff-4c3c-aa56-2e51220bfca9",
  //               isDeleted: false,
  //               isConstant: false
  //             },
  //             defaultCurrency: null,
  //             defaultPnLType:null,
  //             exchangeRateSource:null,
  //             defaultGTNSourceType: null,
  //             sequence: 0,
  //             companyAccount: {
  //               name: "Roses",
  //               companyAccountType: null,
  //               exchangeRateSource: null,
  //               id: "5ea90518-cdb2-45ef-a802-cb855eae9389",
  //               isDeleted: false,
  //               isConstant: false
  //             },
  //             createdAt: "2024-02-11T20:08:46.579157Z",
  //             createdByUser: null,
  //             modifiedAt: null,
  //             modifiedByUser: null,
  //             id: "45ebf523-7f60-4467-b4b9-d8396cd72f41",
  //             isDeleted: false,
  //             isConstant: false
  //           } as CompanyLegalEntityRef,
  //           originalDocument : null,
  //           splitOn : null,
  //           splitBy : null,
  //           files : [],
  //           documentType : DOCUMENT_TYPES.EmployeePayslip as DocumentTypeRef,
  //           publishedOn : null,
  //           publishedBy : null
  //         } as SplitEmployeeDocumentRef,
  //         employee : null,
  //         nameMatching : false,
  //         addressMatching : false,
  //         birthDateMatching : false,
  //         taxIdMatching: false,
  //         isApproved:  false,
  //         isRejected: false,
  //         approvedRejectedByUser:  null,
  //         approvedRejectedAt:  null,
  //         numberOfPages:  0
  //       } as SplitEmployeeDocumentFileDTO
  //     ],
  //     totalItems : 0
  //   } as LoadResponse<SplitEmployeeDocumentFileDTO>)
  // }

  // public async publishSplitEmployeeDocument (
  //   splitEmployeeDocumentId : string,
  //   documentType : DocumentTypeRef,
  //   date? : Date,
  //   period? : Period
  // ) {
  //   const service = this.useLoadItemsPath("/PublishSplitEmployeeDocument")
  // }
}
